<template>
  <page-loader v-if="loadingStatus == 'loading'" />
  <div v-else class="contain-section">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-7 col-xl-8">
        <div class="inner-box">
          <div class="banner-box">
            <img class="rounded-4 h-400 img-row-feedback" :src="overview && overview?.main_image && overview?.main_image.length > 0
              ? overview.main_image[0].url
              : ''
              " alt="Logo" />
          </div>
          <div class="inner-content">
            <h3 class="mb-3 mb-sm-3">{{ overview ? overview.heading : "" }}</h3>
            <div v-html="overview ? overview.text : ''"></div>
            <figure class="m-auto mt-5">
              <img :src="overview && overview?.sub_image && overview?.sub_image.length > 0
                ? overview.sub_image[0].url
                : ''
                " alt="Logo" class="img-fluid" />
            </figure>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-5 col-xl-4">
        <div class="right-bar">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-12 mb-0 mb-sm-4">
                <div class="hightlight-box parental-color">
                  <span>Your Haplogroup is</span>
                  <h4>{{ fatherlineStore.result.haplogroup }}</h4>
                </div>
              </div>
              <div v-if="fatherlineStore.result.subclade" class="col-sm-12 mb-0 mb-sm-4">
                <div class="hightlight-box parental-color">
                  <span>Your haplotype is</span>
                  <h4>{{ fatherlineStore.result.subclade }}</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="population-group">
            <h4>
              {{
                overview && overview.right_section
                  ? overview.right_section[0].heading
                  : ""
              }}
            </h4>
            <div v-html="overview && overview?.right_section
              ? overview.right_section[0].description
              : ''
              "></div>
            <img :src="overview && overview?.right_section
              ? overview.right_section[0].main_image[0].url
              : ''
              " />
            <router-link to="/fatherline/history" class="load-btn m-auto">{{
              overview && overview.right_section
                ? overview.right_section[0].button_text
                : ""
            }}</router-link>
          </div>

          <div class="population-group">
            <h4>
              {{
                overview && overview.right_section
                  ? overview.right_section[1].heading
                  : ""
              }}
            </h4>
            <div v-html="overview && overview?.right_section ? overview.right_section[1].text : ''
              "></div>
            <!-- <img
              :src="
                overview && overview?.right_section
                  ? overview.right_section[1].main_image[0].url
                  : ''
              "
            /> -->
            <div class="row">
              <div id="col-map-distribution" class="col-sm-12 map-card-wrapper"
                style="height:250px; min-height:250px; max-height:250px; overflow:hidden;">
                <DistributionMap v-if="showMap && stagedCoverageData" v-model="selectedRegion"
                  :coverage-data="stagedCoverageData" :gender="'fatherline'" :id="'distributionMapDv'"
                  :auto-fit="true" />
              </div>
            </div>

            <router-link to="/fatherline/distribution-map" class="load-btn m-auto">{{
              overview && overview.right_section
                ? overview.right_section[1].button_text
                : ""
            }}</router-link>
          </div>

          <div class="population-group">
            <h4>
              {{
                overview && overview.right_section
                  ? overview.right_section[2].heading
                  : ""
              }}
            </h4>
            <div v-html="overview && overview?.right_section
              ? overview.right_section[2].description
              : ''
              "></div>
            <!-- <img
              :src="
                overview && overview?.right_section
                  ? overview.right_section[2].main_image[0].url
                  : ''
              "
            /> -->
            <div class="row">
              <div id="col-map-migration" class="col-sm-12"
                style="height: 250px;min-height: 250px; max-height: 250px; overflow: hidden;">
                <MigrationMap :result="fatherlineStore.result" type="ydna" />
              </div>
            </div>
            <router-link to="/fatherline/migration-map" class="load-btn m-auto">{{
              overview && overview.right_section
                ? overview.right_section[2].button_text
                : ""
            }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../../styles/pages/ancentry/recent-ancetry.scss";
import { ref } from "vue";
import { useFatherlineStore } from "@/store/parentalStore";
import { getFatherlineOverview } from "@/services/fatherline";
import DistributionMap from "@/components/ancestry/DistributionMap.vue";
import MigrationMap from "@/components/ancestry/MigrationMap.vue";

const loadingStatus = ref("loading");
const overview = ref({});
const result = ref(null);
const showMap = ref(false);
const selectedRegion = ref(null);
const stagedCoverageData = ref();

export default {
  name: "AncestrySection",
  components: {
    MigrationMap,  // ✅ register component
    DistributionMap
  },
  data() {
    return {
      overview,
      result,
      showMap,
      loadingStatus,
      selectedRegion,
      stagedCoverageData,
      fatherlineStore: useFatherlineStore()
    };
  },
  async mounted() {
    // Fetch overview
    this.overview = await getFatherlineOverview();
    this.loadingStatus = "loaded";

    // Fetch motherline result
    try {
      await this.fatherlineStore.getResult();
      if (!this.fatherlineStore.result) {
        throw new Error("No result");
      }
      console.log('Result fetched:', this.fatherlineStore.result);
      this.updateStagedCoverageData();
    } catch (error) {
      console.error('Error fetching result:', error);
    }
  },
  methods: {
    updateStagedCoverageData() {
      if (this.fatherlineStore.result) {
        this.result = this.fatherlineStore.result;
        this.selectedRegion = this.fatherlineStore.result?.distribution[0]?.id;
        this.showMap = true;
        this.loadingStatus = "loaded";
        if (this.fatherlineStore.result?.distribution) {
          this.stagedCoverageData = {
            type: "geojson",
            data: {
              id: "coverageMapData",
              type: "FeatureCollection",
              features: this.fatherlineStore.result.distribution
                .map(({ geoJson, ...properties }) => ({
                  ...JSON.parse(geoJson),
                  id: properties.id,
                  properties,
                }))
                .filter((el) => el.geometry !== undefined),
            },
          };
          console.log("Staged coverage data updated:", this.stagedCoverageData);
        }
        console.log('Staged coverage data updated:', this.result);
      } else {
        console.error('No distribution data found in result.');
      }

    },
    scrollToTop() {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style scoped>
#col-map-migration>*:not(#map) {
  display: none;
}

#col-map-distribution,
#col-map-migration {
  margin-bottom: 20px;
}

.map-card-wrapper {
  height: 250px;
  overflow: hidden;
  border-radius: 20px;
  padding: 0 !important;
}
</style>